import React from 'react';
import './controlBoard.css';

import Button, {BUTTON_TYPES} from '../Button';
import closeIcon from '../../assets/icons/close-black.png';

export default function ControlBoard(props) {
  const {headingLabel, children, showCancel, onDone, onCancel, doneText} = props;

  return (
    <div className="control-board">
      <div className="control-board-heading">
        {headingLabel}
        <Button
          type={BUTTON_TYPES.ICON}
          icon={closeIcon}
          altText="close"
          onClick={onDone}
          style={{float: 'right', marginTop: 5}}
        />
      </div>
      <div className="control-board-content">{children || null}</div>
      <div className="control-board-button-container">
        {showCancel && (
          <Button label="Cancel" type={BUTTON_TYPES.CANCEL} style={{marginRight: 10}} onClick={onCancel}/>
        )}
        <Button label={doneText || "Done"} type={BUTTON_TYPES.CTA} onClick={onDone} />
      </div>
    </div>
  );
}
